export const SEND_CONTACT_HRTABLE = "SEND_CONTACT_HRTABLE";
export const SEND_CONTACT_HRTABLE_SUCCESS = "SEND_CONTACT_HRTABLE_SUCCESS";
export const SEND_CONTACT_HRTABLE_FAILED = "SEND_CONTACT_HRTABLE_FAILED";

export const SEND_CONTACT_MONEYTABLE = "SEND_CONTACT_MONEYTABLE";
export const SEND_CONTACT_MONEYTABLE_SUCCESS = "SEND_CONTACT_MONEYTABLE_SUCCESS";
export const SEND_CONTACT_MONEYTABLE_FAILED = "SEND_CONTACT_MONEYTABLE_FAILED";
export const CLEAR_CONTACT_MONEYTABLE = "CLEAR_CONTACT_MONEYTABLE";

export const SET_BLOG_DATA = "SET_BLOG_DATA";
export const SET_BLOG_DETAIL = "SET_BLOG_DETAIL";
export const SET_BLOG_LOADING = "SET_BLOG_LOADING";

export const CLEAR_NOTIFICATION = "CLEAR_NOTIFICATION";

export const SEND_CONTACT_DAYCASH         = "SEND_CONTACT_DAYCASH";
export const SEND_CONTACT_DAYCASH_SUCCESS = "SEND_CONTACT_DAYCASH_SUCCESS";
export const SEND_CONTACT_DAYCASH_FAILED  = "SEND_CONTACT_DAYCASH_FAILED";
export const CLEAR_CONTACT_DAYCASH        = "CLEAR_CONTACT_DAYCASH";


// WEBPACK FOOTER //
// ./src/actions/types.jsx